var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "SideMenu",
    {
      attrs: {
        title: _vm.sideMenuData.title,
        "side-menu-width": _vm.sideMenuData.contentWidth,
        value: _vm.isTopDialog(_vm.componentName),
        "z-index": 210,
        "side-menu-auto-scroll-y": "",
        "side-menu-is-block": "",
      },
      on: { "side-menu:click-close": _vm.handleDialogClose },
      scopedSlots: _vm._u([
        {
          key: "titleIcon",
          fn: function () {
            return [
              _c("img", {
                staticClass: "ml-1",
                attrs: {
                  src: "/static/_v1/pd/icons/ui-kit/club/club-percent.svg",
                  width: "24",
                  height: "24",
                  alt: "Иконка Процент Клуба",
                },
              }),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c("ClubDesktopInfoModalContent", {
        staticClass: "pa-6",
        attrs: { "pdf-data": _vm.pdfData },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }